import { api } from '../api/client'
import { t } from '../i18n/lingua'
import Conformita from './Conformita'

/** Il quadro DORA sulla pagina di conformità comune.

    Vale per le entità finanziarie e i loro fornitori ICT critici: il
    sottotitolo lo dice, perché per chi è fuori perimetro questa pagina è una
    lente utile, non un obbligo. */
export default function Dora() {
  return (
    <Conformita
      quadro={{
        framework: 'dora',
        titolo: t('DORA Compliance'),
        sottotitolo: t(
          'Conformità al Regolamento UE 2022/2554 (DORA), valutata sui dati raccolti, con evidenza esplicita dei requisiti non misurabili.'
        ),
        notaNonMisurato: t(
          'I requisiti DORA non verificabili tramite l’inventario richiedono evidenze organizzative, tra cui gestione degli incidenti ICT, test di resilienza e registro dei fornitori. Il report li distingue dai controlli misurati, evitando di attribuire conformità in assenza di evidenze.'
        ),
        carica: api.dora,
      }}
    />
  )
}
